/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

/* ADD CUSTOM CATEGORY FLOW COMPONENTS */
import AddCategoryNameIcon from "../../../../components/Settings/CustomCategory/CustomCategoryCreate/AddCategoryNameIcon";
import AddCategoryField from "../../../../components/Settings/CustomCategory/CustomCategoryCreate/AddCategoryField";

/* IMPORT COMPONENTS */
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SvgComponent from "../../../../components/_utils/SVGComponent";

/* IMPORT THUNK */

import {
  createCustomCategory,
  editCustomCategory,
} from "../../../../redux/features/customCategory";

/* IMPORT UTILS */
import TEXT from "../../../../utils/globalText";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import { beneCategories } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const CustomCategoryCreate = ({ flow }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedCategoryIdForEdit, setselectedCategoryIdForEdit] =
    useState(null);

  /* STATES FOR STEPPER */
  const [activeStep, setActiveStep] = useState(0);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(false);

  /* STATES FOR STEP 1 */
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [categoryIcon, setCategoryIcon] = useState("");
  const [previousCategoryIcon, setPreviousCategoryIcon] = useState("");
  const [iconColor, setIconColor] = useState("");
  const [previousIconColor, setPreviousIconColor] = useState("");
  const [previousCategoryName, setPreviousCategoryName] = useState("");
  const [previousCategoryDescription, setPreviousCategoryDescription] =
    useState("");

  /* STATES FOR STEP 2 */
  const [fieldName, setFieldName] = useState("");
  const [fieldType, setFieldType] = useState("");
  const [toggleDescription, setToggleDescription] = useState("");
  const [fieldMandatory, setFieldMandatory] = useState(false);
  const [options, setOptions] = useState([{ id: Date.now(), value: "" }]);

  const [fieldDetails, setFieldDetails] = useState([]);
  const [previousFieldDetails, setPreviousFieldDetails] = useState([]);

  const [isClearActive, setIsClearActive] = useState(false);
  const [isConfirmActive, setIsConfirmActive] = useState(false);
  const [showFieldConfig, setShowFieldConfig] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [fieldDataArrayAreSimilar, setFieldDataArrayAreSimilar] =
    useState(false);

  const [step2NextBtnEnabled, setStep2NextBtnEnabled] = useState(false);
  /* STATES FOR DELETING FIELD */
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteFieldIndex, setDeleteFieldIndex] = useState();
  const [showLoader, setShowLoader] = useState(false);

  /* Array comprising of steps for PrimaryStepper component */
  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText: "Enter category name and select icon",
    },
    {
      previousText: "Previous",
      nextText: flow === "edit" ? "Update" : "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: step2NextBtnEnabled,
      stepperText: "Setup additional details (optional)",
      extraInfoSubText: TEXT?.ADDITIONAL_DETAILS_DESCRIPTION,
      extraInfoShow: true,
    },
  ];

  useEffect(() => {
    if (flow === "edit") {
      setselectedCategoryIdForEdit(location?.state.id);

      setCategoryName(location?.state?.name);
      setPreviousCategoryName(location?.state?.name);

      setCategoryDescription(location?.state?.description);
      setPreviousCategoryDescription(location?.state?.description);

      setCategoryIcon(location?.state?.asset_properties?.resource_name);
      setPreviousCategoryIcon(location?.state?.asset_properties?.resource_name);

      setIconColor(
        `${location?.state?.asset_properties?.colour?.replaceAll("_", "-")}` ||
          "Custom-Category-Blue",
      );
      setPreviousIconColor(location?.state?.asset_properties?.colour);

      setFieldDetails(location?.state?.configuration?.data || []);
      setPreviousFieldDetails(location?.state?.configuration?.data || []);
    }
  }, [location]);

  useEffect(() => {}, [dispatch]);

  const divRef = useRef(null);
  const [divHeight, setDivHeight] = useState(0);

  useEffect(() => {
    if (divRef.current) {
      setDivHeight(divRef.current.offsetHeight);
    }
  }, []);

  useEffect(() => {
    // Deep equality that treats object key order as irrelevant but requires array order to match.
    function arraysEqualInSequence(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length)
        return false;

      const deepEqual = (x, y) => {
        if (x === y) return true;
        if (x == null || y == null) return false;

        if (Array.isArray(x) && Array.isArray(y)) {
          if (x.length !== y.length) return false;
          return x.every((v, i) => deepEqual(v, y[i]));
        }

        if (typeof x === "object" && typeof y === "object") {
          const keysX = Object.keys(x),
            keysY = Object.keys(y);
          if (keysX.length !== keysY.length) return false;
          return keysX.every((k) => keysY.includes(k) && deepEqual(x[k], y[k]));
        }

        return false;
      };

      return a.every((item, i) => deepEqual(item, b[i]));
    }
    if (flow === "edit") {
      setFieldDataArrayAreSimilar(
        arraysEqualInSequence(fieldDetails, previousFieldDetails),
      );
      if (
        activeStep === GlobalConfiguration?.lengthCheckZero &&
        categoryName?.trim()?.length !== GlobalConfiguration?.lengthCheckZero &&
        categoryName?.trim()?.length >=
          GlobalConfiguration?.categoryminLength &&
        categoryDescription?.trim()?.length !==
          GlobalConfiguration?.lengthCheckZero &&
        categoryDescription?.trim()?.length >=
          GlobalConfiguration?.categoryminLength &&
        categoryIcon
      ) {
        setNextButtonEnabled(true);
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        !arraysEqualInSequence(fieldDetails, previousFieldDetails) &&
        editIndex === null &&
        !showFieldConfig
      ) {
        setStep2NextBtnEnabled(true);
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        ((previousCategoryName?.trim() !== categoryName?.trim() &&
          categoryName?.length &&
          previousCategoryName?.length) ||
          (previousCategoryDescription?.trim() !==
            categoryDescription?.trim() &&
            categoryDescription?.length &&
            previousCategoryDescription?.length) ||
          categoryIcon !== previousCategoryIcon ||
          iconColor !== previousIconColor)
      ) {
        if (
          editIndex !== null ||
          editIndex !== undefined ||
          showFieldConfig !== false
        ) {
          setStep2NextBtnEnabled(false);
        } else {
          setStep2NextBtnEnabled(true);
        }
      } else {
        setNextButtonEnabled(false);
        setStep2NextBtnEnabled(false);
      }
    } else {
      if (
        activeStep === GlobalConfiguration?.lengthCheckZero &&
        categoryName?.trim()?.length > GlobalConfiguration?.lengthCheckTwo &&
        categoryName?.length >= GlobalConfiguration?.categoryminLength &&
        categoryDescription?.trim()?.length >
          GlobalConfiguration?.lengthCheckTwo &&
        categoryDescription?.length >= GlobalConfiguration?.categoryminLength &&
        categoryIcon
      ) {
        setNextButtonEnabled(true);
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        editIndex !== null &&
        editIndex !== undefined
      ) {
        setStep2NextBtnEnabled(false);
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        showFieldConfig === false
      ) {
        setStep2NextBtnEnabled(true);
      } else {
        setNextButtonEnabled(false);
        setStep2NextBtnEnabled(false);
      }
    }
  }, [
    activeStep,
    categoryName,
    categoryDescription,
    categoryIcon,
    previousCategoryIcon,
    editIndex,
    showFieldConfig,
    nextButtonEnabled,
    previousFieldDetails,
    fieldDetails,
    iconColor,
    previousIconColor,
    step2NextBtnEnabled,
  ]);

  const handleNext = () => {
    if (
      activeStep === GlobalConfiguration?.lengthCheckZero &&
      categoryName &&
      categoryDescription &&
      categoryIcon
    ) {
      setActiveStep(
        (prevActiveStep) =>
          prevActiveStep + GlobalConfiguration?.lengthCheckOne,
      );
    } else if (activeStep === GlobalConfiguration?.lengthCheckOne) {
      (async () => {
        setStep2NextBtnEnabled(false);

        await createCategory();
      })().finally((x) => {});
    }
  };

  const handleBack = () => {
    setEditIndex(null);
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      navigate(GlobalConfiguration?.navigate_back);
    } else {
      setActiveStep(
        (prevActiveStep) =>
          prevActiveStep - GlobalConfiguration?.lengthCheckOne,
      );
    }
  };

  const createCategory = async () => {
    let response = null;
    if (flow === "edit") {
      response = await dispatch(
        editCustomCategory({
          id: selectedCategoryIdForEdit,
          name: categoryName,
          description: categoryDescription,
          configuration: fieldDetails?.length ? fieldDetails : null,
          asset_properties: { resource_name: categoryIcon, colour: iconColor },
        }),
      );
    } else {
      response = await dispatch(
        createCustomCategory({
          name: categoryName,
          description: categoryDescription,
          configuration: fieldDetails?.length ? fieldDetails : null,
          asset_properties: { resource_name: categoryIcon, colour: iconColor },
        }),
      );
    }
    if (response?.payload?.status === true) {
      dispatch(beneCategories());
      navigate("/settings/category_dashboard");
      if (flow === "edit") {
        CommonToast({
          text: "Category updated successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        CommonToast({
          text: "Category created successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } else if (response?.payload?.response?.data?.errors) {
      setStep2NextBtnEnabled(true);
      const errors = response?.payload?.response?.data?.errors;
      if (errors?.name) {
        CommonToast({
          text: errors?.name?.[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.configuration) {
        CommonToast({
          text: errors?.configuration?.[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.token_expired) {
        CommonToast({
          text: errors?.token_expired?.[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.user_unauthorized) {
        CommonToast({
          text: errors?.user_unauthorized?.[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.asset_properties) {
        CommonToast({
          text: errors?.asset_properties?.[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  const deleteField = (fieldIndexToDelete) => {
    setShowLoader(true);

    setTimeout(() => {
      setFieldDetails((prevFields) => {
        // Remove the item by index
        const updatedFields = prevFields.filter(
          (_, index) => index !== fieldIndexToDelete,
        );

        // Reassign sequential positions
        const reindexedFields = updatedFields.map((field, index) => ({
          ...field,
          position: index + 1,
        }));

        return reindexedFields;
      });

      setShowDeletePopup(false);
      setShowLoader(false);
    }, 500);
  };

  const renderCustomCategoryCreateSteps = () => {
    switch (activeStep) {
      case 0:
        return (
          <AddCategoryNameIcon
            categoryName={categoryName}
            setCategoryName={setCategoryName}
            categoryDescription={categoryDescription}
            setCategoryDescription={setCategoryDescription}
            categoryIcon={categoryIcon}
            setCategoryIcon={setCategoryIcon}
            iconColor={iconColor}
            setIconColor={setIconColor}
          />
        );
      case 1:
        return (
          <AddCategoryField
            showFieldConfig={showFieldConfig}
            setShowFieldConfig={setShowFieldConfig}
            editIndex={editIndex}
            setEditIndex={setEditIndex}
            fieldName={fieldName}
            setFieldName={setFieldName}
            fieldType={fieldType}
            setFieldType={setFieldType}
            toggleDescription={toggleDescription}
            setToggleDescription={setToggleDescription}
            fieldMandatory={fieldMandatory}
            setFieldMandatory={setFieldMandatory}
            options={options}
            setOptions={setOptions}
            fieldDetails={fieldDetails}
            setFieldDetails={setFieldDetails}
            isClearActive={isClearActive}
            setIsClearActive={setIsClearActive}
            isConfirmActive={isConfirmActive}
            setIsConfirmActive={setIsConfirmActive}
            showDeletePopup={showDeletePopup}
            setShowDeletePopup={setShowDeletePopup}
            showLoader={showLoader}
            setDeleteFieldIndex={setDeleteFieldIndex}
            paginationDivHeight={divHeight}
            fieldDataArrayAreSimilar={fieldDataArrayAreSimilar}
            flow={"edit"}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {showDeletePopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Delete field"}
            headerFontWeight="semibold"
            headerFontColor="var(--custom-orange)"
            textSize="font-md"
            subtext="Are you sure you want to delete this field?"
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowDeletePopup(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Delete"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => deleteField(deleteFieldIndex)}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {/*--------------------------*/}

      {/* STEPPER and the associated steps */}
      <div className="w-width-full flex justify-start items-center flex-col bg-primary-bg h-screen overflow-y-hidden">
        {/*Responsive Screen Header or Navbar*/}
        <div className="add-category-responsive-screen-header sticky top-top-base flex flex-col Qsmd:hidden py-padding-sm bg-primary-nav w-width-full z-z-index-header">
          <div className="flex">
            <div
              className="flex items-center justify-center cursor-pointer px-padding-md"
              onClick={handleBack}
            >
              <SvgComponent
                url={
                  "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                }
                height={"var(--icon-sm)"}
                width={"var(--icon-sm)"}
                color={"var(--text-primary)"}
                alt="Back to previous page/step"
              />
            </div>
            <div className="flex flex-col justify-center gap-y-gap-xs">
              <p className="text-font-md text-text-primary font-normal">
                {flow === "edit" ? TEXT?.EDIT_CATEGORY : TEXT?.ADD_CATEGORY}
              </p>
              <p className="text-font-xs text-text-secondary font-semibold">
                {dataArray[activeStep]?.stepperText}
              </p>
            </div>
          </div>

          {/* STEPPER: STEP 2 CONDITIONAL  DIV*/}
          {activeStep === GlobalConfiguration?.lengthCheckOne ? (
            <div className="bg-primary-nav w-width-full mt-margin-sm Qsmd:hidden">
              <div className="mx-auto max-w-tab-width-normal pt-padding-md pb-padding-sm Qmd:py-padding-sm px-padding-sm Qmd:px-padding-base border-t border-solid border-primary-bg">
                <p className="text-font-xs text-text-secondary font-normal">
                  {TEXT.ADDITIONAL_DETAILS_DESCRIPTION}
                </p>
              </div>
            </div>
          ) : null}
        </div>

        <div className="w-full h-navbar-breadcrumb-height hidden Qsmd:flex flex-shrink-0 Qlg:bg-transparent bg-primary-nav"></div>

        <div
          ref={divRef}
          className={`custom-category-create-stepper w-width-full fixed bottom-bottom-base z-z-index-dropdown Qsmd:relative  ${activeStep === GlobalConfiguration?.lengthCheckOne ? "Qsmd:min-h-card-height min-h-topnavbar-min-height" : "h-stepper-moble-height"}`}
        >
          <div className="mx-auto max-w-tab-width-normal">
            <PrimaryStepper
              activeStep={activeStep}
              handleForwardAction={handleNext}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
        </div>
        {<>{renderCustomCategoryCreateSteps()}</>}
      </div>
      {/*------------------------------*/}
    </>
  );
};

export default CustomCategoryCreate;
